import i18n from '@/plugins/i18n/index'

interface DashboardLatestDataHeader {
  title: string
  key: string
  sortable: boolean
  width: string
}

interface StatisticsData {
  title: string
  icon: string
  key: string
  shouldFormat: boolean
}

// The period the dashboard cards are read over (counts by created/confirmation date, sums by payment date).
export const dashboardDaysTypes = [
  { value: 'today', title: i18n.global.t('Today') },
  { value: 'yesterday', title: i18n.global.t('Yesterday') },
  { value: 'thisWeek', title: i18n.global.t('This Week') },
  { value: 'thisMonth', title: i18n.global.t('This Month') },
  { value: 'lastMonth', title: i18n.global.t('Last Month') },
  { value: 'thisFiscalYear', title: i18n.global.t('This Fiscal Year') },
  { value: 'lastFiscalYear', title: i18n.global.t('Last Fiscal Year') },
  { value: 'custom', title: i18n.global.t('Custom') },
  { value: 'all', title: i18n.global.t('All') },
]

// tabler-box-seam
// Admin-only cards, shown after operatorStatisticsData; masked like them until "View".
export const balanceStatisticsData: StatisticsData[] = [
  {
    title: i18n.global.t('Total MC Books Receivable'),
    icon: 'tabler-currency-rupee',
    key: 'totalMcBooksReceivable',
    shouldFormat: true,
  },
  {
    title: i18n.global.t('Total MC Books Received'),
    icon: 'tabler-currency-rupee',
    key: 'totalMcBooksReceived',
    shouldFormat: true,
  },
  {
    title: i18n.global.t('Total MC Books Payable'),
    icon: 'tabler-currency-rupee',
    key: 'totalMcBooksPayable',
    shouldFormat: true,
  },
  {
    title: i18n.global.t('Total MC Books Paid'),
    icon: 'tabler-currency-rupee',
    key: 'totalMcBooksPaid',
    shouldFormat: true,
  },
  {
    title: i18n.global.t('Total MC Books Discount'),
    icon: 'tabler-currency-rupee',
    key: 'totalMcBooksDiscount',
    shouldFormat: true,
  },
  {
    title: i18n.global.t('Total MC Books Balance'),
    icon: 'tabler-currency-rupee',
    key: 'totalMcBooksBalance',
    shouldFormat: true,
  },
  {
    title: i18n.global.t('Total Receivable'),
    icon: 'tabler-currency-rupee',
    key: 'totalReceivable',
    shouldFormat: true,
  },
  {
    title: i18n.global.t('Total Received'),
    icon: 'tabler-currency-rupee',
    key: 'totalReceived',
    shouldFormat: true,
  },
  {
    title: i18n.global.t('Total Payable'),
    icon: 'tabler-currency-rupee',
    key: 'totalPayable',
    shouldFormat: true,
  },
  {
    title: i18n.global.t('Total Paid'),
    icon: 'tabler-currency-rupee',
    key: 'totalPaid',
    shouldFormat: true,
  },
  {
    title: i18n.global.t('Total Discount'),
    icon: 'tabler-currency-rupee',
    key: 'totalDiscount',
    shouldFormat: true,
  },
  {
    title: i18n.global.t('Total Balance'),
    icon: 'tabler-currency-rupee',
    key: 'totalBalance',
    shouldFormat: true,
  },
]

export const operatorStatisticsData: StatisticsData[] = [{
  title: i18n.global.t('Total Loaders'),
  icon: 'tabler-square-rounded-check',
  key: 'totalLoaders',
  shouldFormat: false,
},
{
  title: i18n.global.t('Total Truckers'),
  icon: 'tabler-truck',
  key: 'totalTruckers',
  shouldFormat: false,
},
{
  title: i18n.global.t('Total Hybrid Users'),
  icon: 'tabler-user-circle',
  key: 'totalHybridUsers',
  shouldFormat: false,
},
{
  title: i18n.global.t('Total Trucks'),
  icon: 'tabler-truck',
  key: 'totalTrucks',
  shouldFormat: false,
},
{
  title: i18n.global.t('Total MC Books'),
  icon: 'tabler-user-circle',
  key: 'totalMcBooks',
  shouldFormat: false,
},
{
  title: i18n.global.t('Total Confirmations'),
  icon: 'tabler-bookmark',
  key: 'totalConfirmation',
  shouldFormat: false,
}]

export const ledgerBalance = [
  {
    title: i18n.global.t('Total Receivable'),
    key: 'totalReceivable',
  },
  {
    title: i18n.global.t('Total Received'),
    key: 'totalReceived',
  },
  {
    title: i18n.global.t('Total Payable'),
    key: 'totalPayable',
  },
  {
    title: i18n.global.t('Total Paid'),
    key: 'totalPaid',
  },
  {
    title: i18n.global.t('Total Discount'),
    key: 'totalDiscount',
  },
  {
    title: i18n.global.t('Balance'),
    key: 'balance',
    color: true,
  },

]

export const dashboardLatestDataHeader: DashboardLatestDataHeader[] = [
  { title: 'Confirmation ID', key: 'formattedId', sortable: false, width: '5%' },
  { title: 'Loader Business Name', key: 'loaderBusinessName', sortable: false, width: '5%' },
  { title: 'Loading Point', key: 'loadingPoints', sortable: false, width: '15%' },
  { title: 'Unloading Point', key: 'unloadingPoints', sortable: false, width: '10%' },
  { title: 'Capacity', key: 'capacity', sortable: false, width: '10%' },
  { title: 'Trucker Business Name', key: 'truckerBusinessName', sortable: false, width: '15%' },
  { title: 'Truck No.', key: 'truckNumber', sortable: false, width: '10%' },
  { title: 'FR + PR + OR', key: 'freight', sortable: false, width: '10%' },
  { title: 'Status', key: 'status', sortable: false, width: '5%' },
  { title: 'Timestamp', key: 'timestamp', sortable: false, width: '10%' },
  { title: 'Actions', key: 'actions', sortable: false, width: '5%' },
]
